// src/components/widgets/FormWidgetCreator.tsx
import React from 'react';

const FormWidgetCreator: React.FC = () => {
  return <div>Form Widget Creator - Coming Soon</div>;
};

export default FormWidgetCreator;
